export default function styles(theme) {
    return {
        title: {
            fontSize: "3rem",
            textAlign: "left",
            width: "100%",
            letterSpacing: "1px",
            color: theme.palette.text.primary,
            margin: "0rem",
            padding: "3rem 0rem 1rem",
            [theme.breakpoints.down("sm")]: {
                fontSize: "2rem",
            },
        },
        secondaryTitle: {
            fontSize: "2rem",
            textAlign: "left",
            width: "100%",
            letterSpacing: "1px",
            color: theme.palette.text.primary,
            margin: "0rem",
            padding: "1rem 0rem",
            [theme.breakpoints.down("sm")]: {
                fontSize: "2rem",
            },
        },
        description: {
            textAlign: 'left',
            width: '100% !important',
            color: theme.palette.text.tertiary,
        },
        profileHeader: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '20px',
            width: '100%',
            margin: '40px auto 80px',
            maxWidth: '60%',
            [theme.breakpoints.down("sm")]: {
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                maxWidth: '100%',
                gap: '20px',
                margin: '40px auto',
            },
        },
        name: {
            fontSize: "2rem",
            textAlign: "left",
            width: "100%",
            letterSpacing: "1px",
            color: theme.palette.text.primary,
            margin: "0rem",
            padding: "1rem 0rem",
            [theme.breakpoints.down("sm")]: {
                fontSize: "2rem",
                textAlign: "center",
            },
        },
        bio: {
            color: theme.palette.text.tertiary,
            [theme.breakpoints.down("sm")]: {
                textAlign: "center",
                maxWidth: '100% !important',
            }
        },
        socials: {
            display: 'flex',
            flexWrap: 'wrap',
            margin: '0px 0px 0px -10px',
            padding: '0',
            [theme.breakpoints.down("sm")]: {
                alignItems: 'center',
                justifyContent: 'center',
            }
        },
        content: {
            maxWidth: '60%',
            margin: '40px auto',
            [theme.breakpoints.down("sm")]: {
                maxWidth: '100%',
            },
        },
        cardsContainer: {
            display: 'flex',
            flexDirection:'column',
            flexWrap: 'noWrap',
            gap: '20px',
            webkitOverflowScrolling: 'touch',
            scrollSnapType: 'x mandatory',
            scrollbarWidth: 'thin',
            paddingBottom: '1rem',
            "&::-webkit-scrollbar": {
                height: '4px !important',
            },
            "&::-webkit-scrollbar-track": {
                backgroundColor: theme.palette.primary.main,
            },
            "&::-webkit-scrollbar-thumb": {
                backgroundColor: '#2e333d',
                cursor: 'pointer',
            },
            [theme.breakpoints.down("sm")]: {
                overflowX: 'auto',
                flexDirection:'row',
            },
        },
    };
}
